module.exports = "<ngx-monaco-editor class=\"editor\" [options]=\"options\" [ngModel]=\"js\" (ngModelChange)=\"applyChange($event)\"></ngx-monaco-editor>\n"